import { ZodType, z } from 'zod';
import { AuthenticationInfo } from '@/model/auth';

export const authenticationInfoSchema = z.object({
  twofa_session: z.string(),
  name: z.string(),
  uuid: z.string(),
}) satisfies ZodType<AuthenticationInfo>;
